import * as types from '../actions/knowledgeBaseActions'

export default function reducer(
  state = {
    knowledgeBaseTree: [],
    knowledgeBaseFaq: [],
    loading: false
  },
  action
) {
  switch (action.type) {
    case types.FETCH_KNOWLEDGEBASES:
      return {
        ...state,
        loading: true
      }

    case types.FETCH_KNOWLEDGEBASES_FULFILLED:
      return {
        ...state,
        knowledgeBaseTree: action.knowledgeBaseTree,
        knowledgeBaseFaq: action.knowledgeBaseFaq,
        knowledgeBaseFlatList: action.knowledgeBaseFlatList,
        loading: false
      }

    case types.FETCH_KNOWLEDGEBASES_REJECTED:
      return {
        ...state,
        error: action.error,
        loading: false
      }

    default:
      return state
  }
}
